'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_patterns_ServiceIcon_ServiceIcon = require('../ServiceIcon/ServiceIcon.cjs.js');
const components_patterns_ServiceIcons_ServiceIconNumeric = require('./ServiceIconNumeric.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const serviceIcons = "_service-icons_667aj_1";
const styles = {
	serviceIcons: serviceIcons
};

const ServiceIcons = ({ "aria-label": ariaLabel, hasBorder = true, hasWhiteBackground = false, maxServices = 6, renderServiceIcon, services, size = "medium", isBlock }) => {
  const props = {
    "aria-label": ariaLabel,
    hasBorder,
    services,
    hasWhiteBackground,
    maxServices,
    renderServiceIcon,
    size,
    isBlock
  };
  const label = ariaLabel || `${services.length} apps mentioned`;
  const hasExtraServices = services.length > maxServices;
  const numServicesHidden = hasExtraServices ? services.length - maxServices + 1 : 0;
  const numServicesShown = hasExtraServices ? maxServices - 1 : services.length;
  let visibleServices = [];
  if (numServicesShown === 1) {
    visibleServices = [services[0]];
  } else if (numServicesShown >= 2) {
    visibleServices = [
      ...services.slice(0, numServicesShown - 1),
      services[services.length - 1]
    ];
  }
  const icons = visibleServices.map((service, idx) => React__default.default.createElement("li", { key: idx, "data-zds": true }, renderServiceIcon ? renderServiceIcon(service, props) : React__default.default.createElement(components_patterns_ServiceIcon_ServiceIcon.ServiceIcon, { hasBorder, hasWhiteBackground, serviceName: service.name, size, src: service.src })));
  if (hasExtraServices) {
    const hiddenServicesCountIcon = React__default.default.createElement(
      "li",
      { key: `remainder-${numServicesHidden}`, "data-zds": true },
      React__default.default.createElement(components_patterns_ServiceIcons_ServiceIconNumeric.ServiceIconNumeric, { size, number: numServicesHidden, hasBorder, hasWhiteBackground })
    );
    if (maxServices > 2)
      icons.splice(-1, 0, hiddenServicesCountIcon);
    else
      icons.push(hiddenServicesCountIcon);
  }
  return React__default.default.createElement("ul", { "aria-label": label, className: styles.serviceIcons, "data-is-block": isBlock, "data-zds": true }, icons);
};

exports.ServiceIcons = ServiceIcons;
//# sourceMappingURL=ServiceIcons.cjs.js.map
